import RestaurentBanner from './RestaurentBanner'
import RestaurentFilter from './RestaurentFilter'
import FilterSlider from './FilterSlider'
import { useEffect, useRef, useState } from 'react';
import FilterDataSlider from './FilterDataSlider';
import { useSelector } from 'react-redux';
import SpcificPageModal from '../../Modals/SpcificPageModal';
import { apiData } from '../../../actions';
import DataLoader from '../../../Utils/DataLoader';

export default function Index() {
  const place = useSelector(state => state.place);
  const topRef = useRef(null);
  const filterResultRef = useRef(null);
  const [searchValue, setSearchValue] = useState("");
  const [checkedFilters, setCheckedFilters] = useState({});
  const [specificModal, setSpecificModal] = useState(false);
  const [sliderData, setSliderData] = useState(null);
  const [dynamicSliderData, setDynamicSliderData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [loadMoreLoading, setLoadMoreLoading] = useState(false);
  const [limit, setLimit] = useState(12);

  const isLoadMoreRef = useRef(false);

  const hasActiveFilter =
    searchValue.trim() !== "" || Object.keys(checkedFilters).length > 0;

  const handleReset = () => {
    setSearchValue("");
    setCheckedFilters({});
    setDynamicSliderData([]);
    setSliderData(null);
    setLimit(12);
  };


  const fetchData = async () => {
    try {
      const activeFilters = Object.keys(checkedFilters);
      const isFiltered =
        activeFilters.length > 0 || searchValue.trim().length > 0;

      if (isFiltered && limit > 12) {
        setLoadMoreLoading(true);
      } else {
        setLoader(true);
      }


      if (isFiltered) {
        const payload = {
          city: place,
          keyword: searchValue.trim() || activeFilters.join(","),
          limit: limit,
        };

        const res = await apiData.restaurantDealsFilterSearch(payload);

        setDynamicSliderData(prev =>
          limit === 12 ? res : [...prev, ...res]
        );
      } else {
        const res = await apiData.restaurantDealsSearch({ city: place });
        setSliderData(res);
        setDynamicSliderData([]);
      }
    } catch (err) {
      console.error(err);
      setDynamicSliderData([]);
      setSliderData(null);
    } finally {
      setLoader(false);
      setLoadMoreLoading(false);
    }
  };

  const handleLoadMore = () => {
    isLoadMoreRef.current = true;
    setLimit(prev => prev + 12);

  };

  useEffect(() => {
    setLimit(12);
    setDynamicSliderData([]);
  }, [searchValue, JSON.stringify(checkedFilters), place]);


  useEffect(() => {
    fetchData();
  }, [place, searchValue, checkedFilters, limit]);


  useEffect(() => {
    const hasSeenPopup = localStorage.getItem("hasSeenSpecficPopup");

    if (!hasSeenPopup) {

      setSpecificModal(true);
      localStorage.setItem("hasSeenSpecficPopup", "true");
    }

    if (place && !hasSeenPopup) {
      setSpecificModal(true);
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        localStorage.setItem("lastSeen", Date.now());
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [place]);

  useEffect(() => {
    if (
      Object.keys(checkedFilters).length > 0 &&
      dynamicSliderData.length > 0 &&
      filterResultRef.current &&
      !isLoadMoreRef.current
    ) {
      filterResultRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      isLoadMoreRef.current = false;
    }
  }, [dynamicSliderData.length, checkedFilters]);


  useEffect(() => {
    if (Object.keys(checkedFilters).length === 0 && topRef.current) {
      topRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [checkedFilters]);



  return (
    <>
      <div ref={topRef}>
        <RestaurentBanner />
      </div>
      <section className="section-equal-padding top-spacing170 top-spacing-120 bg-white">
        <div className="container-fluid">
          <div className='row'>
            <RestaurentFilter
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              checkedFilters={checkedFilters}
              setCheckedFilters={setCheckedFilters}
              onReset={handleReset} />
            <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-9">
              {loader && !loadMoreLoading && (
                <div className="d-flex justify-content-center align-items-center py-5">
                  <DataLoader />
                </div>
              )}

              {!loader && sliderData && (
                <FilterSlider setCheckedFilters={setCheckedFilters} sliderData={sliderData} />
              )}

              {!loader && hasActiveFilter && (
                <div ref={filterResultRef}>
                  <FilterDataSlider
                    isLoading={loadMoreLoading}
                    onLoadMore={handleLoadMore}
                    checkedFilters={checkedFilters}
                    sliderData={dynamicSliderData}
                  />
                </div>
              )}
            </div>
          </div>

        </div>
      </section>

      {specificModal && (
        <SpcificPageModal
          specificModal={specificModal}
          setSpecificModal={setSpecificModal}
        />
      )}
    </>
  )
}
